/**
 * Sort array numerally
 * @param {Object} a First item
 * @param {Object} b Second item
 * @param {string} key Key to compare
 */
export default function (a, b, key) {
  return a[key] - b[key]
}
